export let changeToSecondd = obj => {
  let arr = obj.split(":")
  return arr[0] * 3600 + arr[1] * 60
}
export let changeToString = obj => {
  let h = Math.floor(obj / 3600) 
  let m = Math.floor((obj - 3600 * h) / 60)
  // console.log((h < 10? ('0' + h): h) + ':' + (m < 10? ('0' + m) : m));
  return '' + (h < 10? ('0' + h): h) + ':' + (m < 10? ('0' + m) : m)
}
export let reloadErrorImg = url => {
  if('?error='.indexOf(url) === -1){
    url += '?error=1'
  }else{
    let err = url.split('?error=')[1]
    if(err - 0 < 5){
      url = url.split('?error=')[0] + '?error=' + (err - 0 + 1)
    }
  }
  return url
}